import React, { useEffect } from 'react';
import './App.css';
import Header from './components/header/Header';
import Hero from './components/home/Hero';
import About from './components/about/About';
import Skills from './components/skills/Skills';
import Quali from './components/qualification/Quali';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import Scrollup from './components/scrollup/Scrollup';
import Portfolio from './components/portfolio/Portfolio';
import Exp from './components/experience/Exp';
import ParticleBackground from './components/particles/ParticleBackground';

function App() {
  useEffect(() => {
    // Scroll reveal observer
    const revealElements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .stagger-children');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    revealElements.forEach(el => observer.observe(el));

    return () => {
      revealElements.forEach(el => observer.unobserve(el));
    };
  }, []);

  return (
    <>
      <ParticleBackground />
      <Header />

      <main>
        <Hero />
        <About />
        <Skills />
        <Quali />
        <Exp />
        <Portfolio />
        <Contact />
      </main>

      <Footer />
      <Scrollup />
    </>
  );
}

export default App;
